/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Entity } from '../../models/entity';

export interface ApiExcelPdsImportPost$Json$Params {
      body?: {
'formFile'?: Blob;
}
}

export function apiExcelPdsImportPost$Json(http: HttpClient, rootUrl: string, params?: ApiExcelPdsImportPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Entity>> {
  const rb = new RequestBuilder(rootUrl, apiExcelPdsImportPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Entity>;
    })
  );
}

apiExcelPdsImportPost$Json.PATH = '/api/Excel/PDS_Import';
